"use strict";

exports.__esModule = true;
exports.DaysOfTheWeekSelector = DaysOfTheWeekSelector;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _ = require("..");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function DaysOfTheWeekSelector(props) {
  var handleCheckBoxClick = function handleCheckBoxClick(e) {
    var _props$margin = props.margin,
      margin = _props$margin === void 0 ? "auto" : _props$margin,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === void 0 ? 700 : _props$maxWidth,
      _props$inline = props.inline,
      inline = _props$inline === void 0 ? true : _props$inline,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$selectedDays = props.selectedDays,
      selectedDays = _props$selectedDays === void 0 ? new Array() : _props$selectedDays,
      onSelect = props.onSelect;
    var nameOfDay = e.target.name;
    var isArrayIncudesDay = selectedDays.includes(nameOfDay);
    var daysToReturn = [].concat(selectedDays);
    if (!isArrayIncudesDay) {
      daysToReturn.push(nameOfDay);
    } else if (isArrayIncudesDay) {
      daysToReturn = selectedDays.filter(function (item) {
        return item !== nameOfDay;
      });
    }
    onSelect(daysToReturn);
  };
  return /*#__PURE__*/_react["default"].createElement(_.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        maxWidth: props.maxWidth,
        margin: props.margin
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
      inline: props.inline,
      disabled: props.disabled,
      checked: props.selectedDays.includes("monday"),
      name: "monday",
      onChange: handleCheckBoxClick,
      label: translate("DeviceSelector.day.monday", "Monday"),
      "data-testid": "MondayCheckboxTestId"
    }), /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
      inline: props.inline,
      disabled: props.disabled,
      checked: props.selectedDays.includes("tuesday"),
      name: "tuesday",
      onChange: handleCheckBoxClick,
      label: translate("DeviceSelector.day.tuesday", "Tuesday"),
      "data-testid": "TuesdayCheckboxTestId"
    }), /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
      inline: props.inline,
      disabled: props.disabled,
      checked: props.selectedDays.includes("wednesday"),
      name: "wednesday",
      onChange: handleCheckBoxClick,
      label: translate("DeviceSelector.day.wednesday", "Wednesday"),
      "data-testid": "WednesdayCheckboxTestId"
    }), /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
      inline: props.inline,
      disabled: props.disabled,
      checked: props.selectedDays.includes("thursday"),
      name: "thursday",
      onChange: handleCheckBoxClick,
      label: translate("DeviceSelector.day.thursday", "Thursday"),
      "data-testid": "ThursdayCheckboxTestId"
    }), /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
      inline: props.inline,
      disabled: props.disabled,
      checked: props.selectedDays.includes("friday"),
      name: "friday",
      onChange: handleCheckBoxClick,
      label: translate("DeviceSelector.day.friday", "Friday"),
      "data-testid": "FridayCheckboxTestId"
    }), /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
      inline: props.inline,
      disabled: props.disabled,
      checked: props.selectedDays.includes("saturday"),
      name: "saturday",
      onChange: handleCheckBoxClick,
      label: translate("DeviceSelector.day.saturday", "Saturday"),
      "data-testid": "SaturdayCheckboxTestId"
    }), /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
      inline: props.inline,
      disabled: props.disabled,
      checked: props.selectedDays.includes("sunday"),
      name: "sunday",
      onChange: handleCheckBoxClick,
      label: translate("DeviceSelector.day.sunday", "Sunday"),
      "data-testid": "SundayCheckboxTestId"
    }));
  });
}